<template>
  <v-container fill-height fluid>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-school
            </v-icon>
            <span class="title">Data Pengajuan Beasiswa</span>
          </v-card-title>
          <v-tabs
            v-model="tabsurat"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows
            @change="changedTab">
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Pengajuan
              <v-icon large>playlist_add_check</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew" v-if="false">
              Buat Baru
              <v-icon large>playlist_add</v-icon>
            </v-tab>
            <v-tab href="#tab-report" v-if="false">
              Laporan
              <v-icon large>assessment</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabsurat">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container fluid>
                    <v-row justify="center">
                      <v-col cols="12" md="2">
                        <v-autocomplete
                          name="jenisbeasiswa"
                          v-model="filter.jenis_bs"
                          :items="listjenisbeasiswa"
                          item-value="id_jb"
                          item-text="nama_jb"
                          label="Jenis Beasiswa"
                          @change="getSurat">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          :items="listprodi"
                          name="prodi"
                          v-model="filter.prodi"
                          label="Program Studi"
                          item-value="nama_prodi"
                          item-text="nama_prodi"
                          @change="getSurat">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select
                          :items="liststatus"
                          name="statussurat"
                          v-model="filter.status"
                          label="Status"
                          @change="getSurat">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.changest">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.tanggal_surat`]="{ item }">
                            {{ item.tanggal_surat | dateToAge }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              :to="{ name: 'BeasiswaDetailJur', params: { kodesurat: item.id_bs }}"
                              small
                              icon>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew" v-if="false">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <alertsp :alertdata="alertdata"></alertsp>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddsurat"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                name="jenisbeasiswa"
                                v-model="addsurat.jenis_bs"
                                :items="listjenisbeasiswa"
                                item-value="id_jb"
                                item-text="nama_jb"
                                return-object
                                @change="updateJenisBeasiswa"
                                label="Jenis Beasiswa">
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addsurat.nik_surat"
                                :counter="16"
                                :rules="[rules.required, rules.nik]"
                                label="NIK"
                                name="nik"
                                required
                                @blur="checkNik"
                                :hint="datanik.nama"
                                persistent-hint>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addsurat.deskripsi_surat"
                                auto-grow
                                label="Deskripsi Surat"
                                :rules="[rules.required]"
                                rows="1"
                                :hint="'Lengkapi deskripsi sesuai dengan keperluan'"
                                persistent-hint>
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addsurat.peruntukan_surat"
                                auto-grow
                                label="Keperluan Surat"
                                :rules="[rules.required]"
                                rows="1"
                                :hint="'Tuliskan tujuan pembuatan surat'"
                                persistent-hint>
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <div class="text-center" v-if="loading.addsurat">
                                <v-progress-circular
                                  :width="3"
                                  color="red"
                                  indeterminate>
                                </v-progress-circular>
                              </div>
                              <v-btn
                                v-if="!loading.addsurat"
                                large
                                block
                                :disabled="!formadd.valid || !datanik.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-report">
              <v-card flat>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12" class="pt-0">
                            <v-card outlined :color="maincolor" dark>
                              <v-card-title class="title py-3">Filter</v-card-title>
                              <v-divider></v-divider>
                              <v-card-text>
                                <alertsp :alertdata="alertdata"></alertsp>
                                <v-autocomplete
                                  name="jenisbeasiswa"
                                  v-model="report.id_jb"
                                  :items="listjenisbeasiswa"
                                  item-value="id_jb"
                                  item-text="nama_jb"
                                  label="Jenis Beasiswa">
                                </v-autocomplete>
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-btn
                                  text
                                  :loading="loading.report"
                                  :disabled="loading.report"
                                  @click="getReport">
                                  Tampilkan
                                </v-btn>
                                <v-btn
                                  text
                                  color="yellow"
                                  :loading="loading.reportprint"
                                  :disabled="loading.reportprint"
                                  @click="downloadReport">
                                  Download
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <v-card
                              :color="maincolor"
                              dark
                              outlined>
                              <v-card-title class="title py-3">Surat Berdasar Jurusan</v-card-title>
                              <v-card-text class="white text--primary py-3">
                                <v-data-table
                                  class="table-nowrap"
                                  light
                                  :headers="summary.jurusan.headers"
                                  :items="summary.jurusan.data"
                                  hide-default-footer>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="8" class="pt-0">
                        <v-card
                          :color="maincolor"
                          dark
                          outlined>
                          <v-card-title class="title py-3">Detail Data</v-card-title>
                          <v-card-text class="white text--primary py-3">
                            <v-data-table
                              light
                              class="table-nowrap"
                              :headers="report.headers"
                              :items="report.data"
                              :search="report.search">
                              <template v-slot:[`item.no_surat`]="{ item }">
                                {{ item.no_surat ? item.no_surat : '-' }}
                              </template>
                              <template v-slot:[`item.lahir`]="{ item }">
                                {{ item.tempat_lahir }}, {{ item.tanggal_lahir }}
                              </template>
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'BeasiswaJur',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      changest: false,
      addsurat: false,
      checknik: false,
      report: false,
      reportprint: false,
    },
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    publickey: '123',
    liststatus: ['permohonan', 'penilaian', 'lulus', 'tolak', 'gagal', 'semua'],
    filter: {
      search: '',
      status: 'permohonan',
      jenis_bs: '',
      prodi: '',
    },
    report: {
      month: '',
      id_jb: '',
      headers: [
        { text: 'NIM', value: 'user_bs' },
        { text: 'Nama', value: 'p_nama' },
        { text: 'Jurusan', value: 'p_jurusan' },
        { text: 'Prodi', value: 'p_prodi' },
        { text: 'T. Nilai', value: 'total_nilai' },
        { text: 'Status', value: 'status_bs' },
      ],
      data: [],
      search: '',
    },
    summary: {
      jurusan: {
        headers: [
          { text: 'Jurusan', value: 'p_jurusan' },
          { text: 'Jumlah', value: 'jum' },
        ],
        data: [],
      },
      jenis: {
        headers: [
          { text: 'Surat', value: 'nama_js' },
          { text: 'Jumlah', value: 'jum' },
        ],
        data: [],
      },
    },
    headers: [
      { text: 'Periode', value: 'period_bs' },
      { text: 'Beasiswa', value: 'nama_jb' },
      { text: 'NIM', value: 'user_bs' },
      { text: 'Nama', value: 'p_nama' },
      { text: 'Tanggal', value: 'tgl_bs' },
      { text: 'T. Nilai', value: 'total_nilai' },
      { text: 'Status', value: 'status_bs' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    listprodi: [],
    listjenisbeasiswa: [],
    addsurat: {
      nik_surat: '',
      kode_surat: '',
      jenis_surat: '',
      jenis_surat_l: '',
      deskripsi_surat: '',
      peruntukan_surat: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    tabsurat: null,
    datanik: {
      valid: false,
      nama: 'nik tidak ditemukan',
    },
    datepick: {
      date: new Date().toISOString().substr(0, 7),
      monthreport: false,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userjur',
    ]),
  },
  mounted() {
    // get data params
    if (this.$route.query.type && this.$route.query.type !== '') {
      this.filter.status = this.$route.query.type;
    }
    if (this.$route.query.tab && this.$route.query.tab !== '') {
      this.changeTab(this.$route.query.tab);
    }
    if (this.$route.query.nik && this.$route.query.nik !== '') {
      this.addsurat.nik_surat = this.$route.query.nik;
      this.checkNik();
    }
    // klian
    if (this.modulklian === '1') {
      this.liststatus = ['permohonan', 'proses', 'siap', 'selesai', 'batal', 'accbanjar', 'semua'];
      // this.filter.status = this.liststatus[0];
    }
    // init request
    this.getJenisBeasiswa();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
  },
  methods: {
    downloadReport() {
      this.alertdata.show = false;
      if (this.tokenscr && this.report.month !== '') {
        this.loading.reportprint = true;
        this.axios
          .get(
            this.api + '/api/surat/report/print',
            {
              params: {
                month: this.report.month,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
              responseType: 'blob',
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'report-surat-' + this.report.month + '.xls');
              document.body.appendChild(link);
              link.click();
            }
            this.loading.reportprint = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.reportprint = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal server error!';
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'warning';
        this.alertdata.text = 'Pilih bulan!';
      }
    },
    changedTab() {
      this.alertdata.show = false;
    },
    getReport() {
      this.alertdata.show = false;
      if (this.tokenscr && this.report.id_jb !== '') {
        this.report.data = [];
        this.summary.jurusan.data = [];
        this.loading.report = true;
        this.axios
          .get(
            this.api + '/api/beasiswa/report',
            {
              params: {
                id_jb: this.report.id_jb,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.report.data = resdata.data;
                this.summary.jurusan.data = resdata.sumjurusan;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal server error!';
            }
            this.loading.report = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.report = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal server error!';
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'warning';
        this.alertdata.text = 'Pilih bulan!';
      }
    },
    changeTab(tabdata) {
      this.tabsurat = tabdata;
    },
    updateJenisBeasiswa(data) {
      this.addsurat.jenis_bs = data.id_jb;
      this.addsurat.period_bs = data.period_jb;
    },
    resetCheckNik() {
      this.datanik = {
        valid: false,
        nama: 'nik tidak ditemukan',
      };
    },
    checkNik() {
      this.resetCheckNik();
      if (this.tokenscr) {
        this.loading.checknik = true;
        this.axios
          .get(
            this.api + '/api/penduduk/nik',
            {
              params: {
                nik: this.addsurat.nik_surat,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false && resdata.data.length > 0) {
                this.datanik.valid = true;
                this.datanik.nama = resdata.data[0].nama;
              }
            }
            this.loading.checknik = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.checknik = false;
          });
      }
    },
    getJenisBeasiswa() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenisbeasiswa/',
            {
              params: {
                status: 'active',
                date: 'all',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listjenisbeasiswa = resdata.data;
                // default
                this.filter.jenis_bs = resdata.data[0].id_jb;
                // get prodi
                this.getProdi();
                // add
                this.addsurat.jenis_bs = resdata.data[0].id_jb;
                this.addsurat.period_bs = resdata.data[0].period_jb;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getProdi() {
      if (this.tokenscr) {
        this.listprodi = [];
        this.loading.changest = true;
        this.axios
          .get(
            this.api + '/api/prodi/',
            {
              params: {
                jurusan: this.userjur,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listprodi = resdata.data;
                // default
                this.filter.prodi = resdata.data[0].nama_prodi;
                // get data
                this.getSurat();
              }
            }
            this.loading.changest = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changest = false;
          });
      }
    },
    getSurat() {
      if (this.tokenscr) {
        this.loading.changest = true;
        this.axios
          .get(
            this.api + '/api/beasiswa/',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.changest = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changest = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddsurat.validate()) {
        if (this.tokenscr) {
          this.loading.addsurat = true;
          // additional data
          this.addsurat.modulklian = this.modulklian;
          // request
          this.axios
            .post(
              this.api + '/api/surat/',
              qs.stringify(
                this.addsurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.addsurat.jenis_surat_l + '" berhasil ditambahkan!';
                  this.getSurat();
                  this.$root.$emit('app-getnotifiaction');
                  this.$refs.formaddsurat.reset();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.addsurat = false;
            })
            .catch((error) => {
              console.log(error);
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.addsurat = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
